<template>
  <v-input :value="value" :rules="rules">
    <template v-if="systemColorsOnly">
      <v-select
        v-model="innerValue"
        :items="computedSystemColors"
        :label="label"
        :rules="rules"
      >
        <template v-slot:selection="data">
          <slot name="selection" v-bind="data">
            <v-avatar left>
              <div
                :style="
                  `width:20px;height:10px;display:inline;background-color:${getSystemColor(
                    data.item
                  )};`
                "
              ></div>
            </v-avatar>
            {{ data.item }}
          </slot>
        </template>
        <template v-slot:item="data">
          <slot name="item" v-bind="data">
            <v-list-item-avatar>
              <div
                :style="
                  `width:20px;height:10px;display:inline;background-color:${getSystemColor(
                    data.item
                  )};`
                "
              ></div>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item }}
              </v-list-item-title>
            </v-list-item-content>
          </slot>
        </template>
      </v-select>
    </template>
    <template v-else-if="hexColorsOnly">
      <label v-if="value === undefined" style="position:absolute;top:0;left:0;">
        {{ label }}
      </label>
      <label
        v-else
        style="position:absolute;top:0;left:0;color:rgba(0, 0, 0, 0.67);font-weight: 400;font-size: 12px;"
      >
        {{ label }}
      </label>
      <div style="margin-top:22px;">
        <v-color-picker
          style="width:55%"
          :value="innerValue"
          @update:color="innerValue=$event"
          :rules="rules"
          mode="hexa"
        ></v-color-picker>
      </div>
    </template>
    <template v-else>
      <v-flex style="margin-right: 5px; flex:none">
        <v-checkbox
          v-model="useSystemColors"
          style="margin-top: 0!important;"
        />
        <!-- <span  > -->
        {{ $t("components.portal.color_selector.use_theme_colors") }}
        <!-- </span> -->
      </v-flex>
      <v-select
        v-if="useSystemColors"
        v-model="innerValue"
        :items="computedSystemColors"
        :label="label"
        :rules="rules"
      >
        <template v-slot:selection="data">
          <slot name="selection" v-bind="data">
            <v-avatar left>
              <div
                :style="
                  `width:20px;height:10px;display:inline;background-color:${getSystemColor(
                    data.item
                  )};`
                "
              ></div>
            </v-avatar>
            {{ data.item }}
          </slot>
        </template>
        <template v-slot:item="data">
          <slot name="item" v-bind="data">
            <v-list-item-avatar>
              <div
                :style="
                  `width:20px;height:10px;display:inline;background-color:${getSystemColor(
                    data.item
                  )};`
                "
              ></div>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item }}
              </v-list-item-title>
            </v-list-item-content>
          </slot>
        </template>
      </v-select>
      <template v-else>
        <label
          v-if="value === undefined"
          style="position:absolute;top:0;left:0;"
        >
          {{ label }}
        </label>
        <label
          v-else
          style="position:absolute;top:0;left:0;color:rgba(0, 0, 0, 0.67);font-weight: 400;font-size: 12px;"
        >
          {{ label }}
        </label>
        <div style="margin-top:22px;">
          <v-color-picker
            style="width:55%"
            v-model="innerValue"
            mode="hexa"
          ></v-color-picker>
        </div>
      </template>
    </template>
  </v-input>
</template>

<script>
export default {
  props: [
    "value",
    "rules",
    "label",
    "systemColors",
    "systemColorsOnly",
    "hexColorsOnly",
  ],
  data() {
    return {
      innerValue: null,
      useSystemColors: false,
      colors: [
        {
          ColorName: "AliceBlue",
          RGBValue: "rgb(240, 248, 255)",
          HexadecimalValue: "#F0F8FF",
        },
        {
          ColorName: "AntiqueWhite",
          RGBValue: "rgb(250, 235, 215)",
          HexadecimalValue: "#FAEBD7",
        },
        {
          ColorName: "Aqua",
          RGBValue: "rgb(0, 255, 255)",
          HexadecimalValue: "#00FFFF",
        },
        {
          ColorName: "Aquamarine",
          RGBValue: "rgb(127, 255, 212)",
          HexadecimalValue: "#7FFFD4",
        },
        {
          ColorName: "Azure",
          RGBValue: "rgb(240, 255, 255)",
          HexadecimalValue: "#F0FFFF",
        },
        {
          ColorName: "Beige",
          RGBValue: "rgb(245, 245, 220)",
          HexadecimalValue: "#F5F5DC",
        },
        {
          ColorName: "Bisque",
          RGBValue: "rgb(255, 228, 196)",
          HexadecimalValue: "#FFE4C4",
        },
        {
          ColorName: "Black",
          RGBValue: "rgb(0, 0, 0)",
          HexadecimalValue: "#000000",
        },
        {
          ColorName: "BlanchedAlmond",
          RGBValue: "rgb(255, 235, 205)",
          HexadecimalValue: "#FFEBCD",
        },
        {
          ColorName: "Blue",
          RGBValue: "rgb(0, 0, 255)",
          HexadecimalValue: "#0000FF",
        },
        {
          ColorName: "BlueViolet",
          RGBValue: "rgb(138, 43, 226)",
          HexadecimalValue: "#8A2BE2",
        },
        {
          ColorName: "Brown",
          RGBValue: "rgb(165, 42, 42)",
          HexadecimalValue: "#A52A2A",
        },
        {
          ColorName: "BurlyWood",
          RGBValue: "rgb(222, 184, 135)",
          HexadecimalValue: "#DEB887",
        },
        {
          ColorName: "CadetBlue",
          RGBValue: "rgb(95, 158, 160)",
          HexadecimalValue: "#5F9EA0",
        },
        {
          ColorName: "Chartreuse",
          RGBValue: "rgb(127, 255, 0)",
          HexadecimalValue: "#7FFF00",
        },
        {
          ColorName: "Chocolate",
          RGBValue: "rgb(210, 105, 30)",
          HexadecimalValue: "#D2691E",
        },
        {
          ColorName: "Coral",
          RGBValue: "rgb(255, 127, 80)",
          HexadecimalValue: "#FF7F50",
        },
        {
          ColorName: "CornflowerBlue",
          RGBValue: "rgb(100, 149, 237)",
          HexadecimalValue: "#6495ED",
        },
        {
          ColorName: "Cornsilk",
          RGBValue: "rgb(255, 248, 220)",
          HexadecimalValue: "#FFF8DC",
        },
        {
          ColorName: "Crimson",
          RGBValue: "rgb(220, 20, 60)",
          HexadecimalValue: "#DC143C",
        },
        {
          ColorName: "Cyan",
          RGBValue: "rgb(0, 255, 255)",
          HexadecimalValue: "#00FFFF",
        },
        {
          ColorName: "DarkBlue",
          RGBValue: "rgb(0, 0, 139)",
          HexadecimalValue: "#00008B",
        },
        {
          ColorName: "DarkCyan",
          RGBValue: "rgb(0, 139, 139)",
          HexadecimalValue: "#008B8B",
        },
        {
          ColorName: "DarkGoldenrod",
          RGBValue: "rgb(184, 134, 11)",
          HexadecimalValue: "#B8860B",
        },
        {
          ColorName: "DarkGray",
          RGBValue: "rgb(169, 169, 169)",
          HexadecimalValue: "#A9A9A9",
        },
        {
          ColorName: "DarkGreen",
          RGBValue: "rgb(0, 100, 0)",
          HexadecimalValue: "#006400",
        },
        {
          ColorName: "DarkKhaki",
          RGBValue: "rgb(189, 183, 107)",
          HexadecimalValue: "#BDB76B",
        },
        {
          ColorName: "DarkMagenta",
          RGBValue: "rgb(139, 0, 139)",
          HexadecimalValue: "#8B008B",
        },
        {
          ColorName: "DarkOliveGreen",
          RGBValue: "rgb(85, 107, 47)",
          HexadecimalValue: "#556B2F",
        },
        {
          ColorName: "DarkOrange",
          RGBValue: "rgb(255, 140, 0)",
          HexadecimalValue: "#FF8C00",
        },
        {
          ColorName: "DarkOrchid",
          RGBValue: "rgb(153, 50, 204)",
          HexadecimalValue: "#9932CC",
        },
        {
          ColorName: "DarkRed",
          RGBValue: "rgb(139, 0, 0)",
          HexadecimalValue: "#8B0000",
        },
        {
          ColorName: "DarkSalmon",
          RGBValue: "rgb(233, 150, 122)",
          HexadecimalValue: "#E9967A",
        },
        {
          ColorName: "DarkSeaGreen",
          RGBValue: "rgb(143, 188, 143)",
          HexadecimalValue: "#8FBC8F",
        },
        {
          ColorName: "DarkSlateBlue",
          RGBValue: "rgb(72, 61, 139)",
          HexadecimalValue: "#483D8B",
        },
        {
          ColorName: "DarkSlateGray",
          RGBValue: "rgb(47, 79, 79)",
          HexadecimalValue: "#2F4F4F",
        },
        {
          ColorName: "DarkTurquoise",
          RGBValue: "rgb(0, 206, 209)",
          HexadecimalValue: "#00CED1",
        },
        {
          ColorName: "DarkViolet",
          RGBValue: "rgb(148, 0, 211)",
          HexadecimalValue: "#9400D3",
        },
        {
          ColorName: "DeepPink",
          RGBValue: "rgb(255, 20, 147)",
          HexadecimalValue: "#FF1493",
        },
        {
          ColorName: "DeepSkyBlue",
          RGBValue: "rgb(0, 191, 255)",
          HexadecimalValue: "#00BFFF",
        },
        {
          ColorName: "DimGray",
          RGBValue: "rgb(105, 105, 105)",
          HexadecimalValue: "#696969",
        },
        {
          ColorName: "DodgerBlue",
          RGBValue: "rgb(30, 144, 255)",
          HexadecimalValue: "#1E90FF",
        },
        {
          ColorName: "FireBrick",
          RGBValue: "rgb(178, 34, 34)",
          HexadecimalValue: "#B22222",
        },
        {
          ColorName: "FloralWhite",
          RGBValue: "rgb(255, 250, 240)",
          HexadecimalValue: "#FFFAF0",
        },
        {
          ColorName: "ForestGreen",
          RGBValue: "rgb(34, 139, 34)",
          HexadecimalValue: "#228B22",
        },
        {
          ColorName: "Fuchsia",
          RGBValue: "rgb(255, 0, 255)",
          HexadecimalValue: "#FF00FF",
        },
        {
          ColorName: "Gainsboro",
          RGBValue: "rgb(220, 220, 220)",
          HexadecimalValue: "#DCDCDC",
        },
        {
          ColorName: "GhostWhite",
          RGBValue: "rgb(248, 248, 255)",
          HexadecimalValue: "#F8F8FF",
        },
        {
          ColorName: "Gold",
          RGBValue: "rgb(255, 215, 0)",
          HexadecimalValue: "#FFD700",
        },
        {
          ColorName: "Goldenrod",
          RGBValue: "rgb(218, 165, 32)",
          HexadecimalValue: "#DAA520",
        },
        {
          ColorName: "Gray",
          RGBValue: "rgb(128, 128, 128)",
          HexadecimalValue: "#808080",
        },
        {
          ColorName: "Green",
          RGBValue: "rgb(0, 128, 0)",
          HexadecimalValue: "#008000",
        },
        {
          ColorName: "GreenYellow",
          RGBValue: "rgb(173, 255, 47)",
          HexadecimalValue: "#ADFF2F",
        },
        {
          ColorName: "Honeydew",
          RGBValue: "rgb(240, 255, 240)",
          HexadecimalValue: "#F0FFF0",
        },
        {
          ColorName: "HotPink",
          RGBValue: "rgb(255, 105, 180)",
          HexadecimalValue: "#FF69B4",
        },
        {
          ColorName: "IndianRed",
          RGBValue: "rgb(205, 92, 92)",
          HexadecimalValue: "#CD5C5C",
        },
        {
          ColorName: "Indigo",
          RGBValue: "rgb(75, 0, 130)",
          HexadecimalValue: "#4B0082",
        },
        {
          ColorName: "Ivory",
          RGBValue: "rgb(255, 255, 240)",
          HexadecimalValue: "#FFFFF0",
        },
        {
          ColorName: "Khaki",
          RGBValue: "rgb(240, 230, 140)",
          HexadecimalValue: "#F0E68C",
        },
        {
          ColorName: "Lavender",
          RGBValue: "rgb(230, 230, 250)",
          HexadecimalValue: "#E6E6FA",
        },
        {
          ColorName: "LavenderBlush",
          RGBValue: "rgb(255, 240, 245)",
          HexadecimalValue: "#FFF0F5",
        },
        {
          ColorName: "LawnGreen",
          RGBValue: "rgb(124, 252, 0)",
          HexadecimalValue: "#7CFC00",
        },
        {
          ColorName: "LemonChiffon",
          RGBValue: "rgb(255, 250, 205)",
          HexadecimalValue: "#FFFACD",
        },
        {
          ColorName: "LightBlue",
          RGBValue: "rgb(173, 216, 230)",
          HexadecimalValue: "#ADD8E6",
        },
        {
          ColorName: "LightCoral",
          RGBValue: "rgb(240, 128, 128)",
          HexadecimalValue: "#F08080",
        },
        {
          ColorName: "LightCyan",
          RGBValue: "rgb(224, 255, 255)",
          HexadecimalValue: "#E0FFFF",
        },
        {
          ColorName: "LightGoldenrodYellow",
          RGBValue: "rgb(250, 250, 210)",
          HexadecimalValue: "#FAFAD2",
        },
        {
          ColorName: "LightGreen",
          RGBValue: "rgb(144, 238, 144)",
          HexadecimalValue: "#90EE90",
        },
        {
          ColorName: "LightGrey",
          RGBValue: "rgb(211, 211, 211)",
          HexadecimalValue: "#D3D3D3",
        },
        {
          ColorName: "LightPink",
          RGBValue: "rgb(255, 182, 193)",
          HexadecimalValue: "#FFB6C1",
        },
        {
          ColorName: "LightSalmon",
          RGBValue: "rgb(255, 160, 122)",
          HexadecimalValue: "#FFA07A",
        },
        {
          ColorName: "LightSeaGreen",
          RGBValue: "rgb(32, 178, 170)",
          HexadecimalValue: "#20B2AA",
        },
        {
          ColorName: "LightSkyBlue",
          RGBValue: "rgb(135, 206, 250)",
          HexadecimalValue: "#87CEFA",
        },
        {
          ColorName: "LightSlateGray",
          RGBValue: "rgb(119, 136, 153)",
          HexadecimalValue: "#778899",
        },
        {
          ColorName: "LightSteelBlue",
          RGBValue: "rgb(176, 196, 222)",
          HexadecimalValue: "#B0C4DE",
        },
        {
          ColorName: "LightYellow",
          RGBValue: "rgb(255, 255, 224)",
          HexadecimalValue: "#FFFFE0",
        },
        {
          ColorName: "Lime",
          RGBValue: "rgb(0, 255, 0)",
          HexadecimalValue: "#00FF00",
        },
        {
          ColorName: "LimeGreen",
          RGBValue: "rgb(50, 205, 50)",
          HexadecimalValue: "#32CD32",
        },
        {
          ColorName: "Linen",
          RGBValue: "rgb(250, 240, 230)",
          HexadecimalValue: "#FAF0E6",
        },
        {
          ColorName: "Magenta",
          RGBValue: "rgb(255, 0, 255)",
          HexadecimalValue: "#FF00FF",
        },
        {
          ColorName: "Maroon",
          RGBValue: "rgb(128, 0, 0)",
          HexadecimalValue: "#800000",
        },
        {
          ColorName: "MediumAquamarine",
          RGBValue: "rgb(102, 205, 170)",
          HexadecimalValue: "#66CDAA",
        },
        {
          ColorName: "MediumBlue",
          RGBValue: "rgb(0, 0, 205)",
          HexadecimalValue: "#0000CD",
        },
        {
          ColorName: "MediumOrchid",
          RGBValue: "rgb(186, 85, 211)",
          HexadecimalValue: "#BA55D3",
        },
        {
          ColorName: "MediumPurple",
          RGBValue: "rgb(147, 112, 219)",
          HexadecimalValue: "#9370DB",
        },
        {
          ColorName: "MediumSeaGreen",
          RGBValue: "rgb(60, 179, 113)",
          HexadecimalValue: "#3CB371",
        },
        {
          ColorName: "MediumSlateBlue",
          RGBValue: "rgb(123, 104, 238)",
          HexadecimalValue: "#7B68EE",
        },
        {
          ColorName: "MediumSpringGreen",
          RGBValue: "rgb(0, 250, 154)",
          HexadecimalValue: "#00FA9A",
        },
        {
          ColorName: "MediumTurquoise",
          RGBValue: "rgb(72, 209, 204)",
          HexadecimalValue: "#48D1CC",
        },
        {
          ColorName: "MediumVioletRed",
          RGBValue: "rgb(199, 21, 133)",
          HexadecimalValue: "#C71585",
        },
        {
          ColorName: "MidnightBlue",
          RGBValue: "rgb(25, 25, 112)",
          HexadecimalValue: "#191970",
        },
        {
          ColorName: "MintCream",
          RGBValue: "rgb(245, 255, 250)",
          HexadecimalValue: "#F5FFFA",
        },
        {
          ColorName: "MistyRose",
          RGBValue: "rgb(255, 228, 225)",
          HexadecimalValue: "#FFE4E1",
        },
        {
          ColorName: "Moccasin",
          RGBValue: "rgb(255, 228, 181)",
          HexadecimalValue: "#FFE4B5",
        },
        {
          ColorName: "NavajoWhite",
          RGBValue: "rgb(255, 222, 173)",
          HexadecimalValue: "#FFDEAD",
        },
        {
          ColorName: "Navy",
          RGBValue: "rgb(0, 0, 128)",
          HexadecimalValue: "#000080",
        },
        {
          ColorName: "OldLace",
          RGBValue: "rgb(253, 245, 230)",
          HexadecimalValue: "#FDF5E6",
        },
        {
          ColorName: "Olive",
          RGBValue: "rgb(128, 128, 0)",
          HexadecimalValue: "#808000",
        },
        {
          ColorName: "OliveDrab",
          RGBValue: "rgb(107, 142, 35)",
          HexadecimalValue: "#6B8E23",
        },
        {
          ColorName: "Orange",
          RGBValue: "rgb(255, 165, 0)",
          HexadecimalValue: "#FFA500",
        },
        {
          ColorName: "OrangeRed",
          RGBValue: "rgb(255, 69, 0)",
          HexadecimalValue: "#FF4500",
        },
        {
          ColorName: "Orchid",
          RGBValue: "rgb(218, 112, 214)",
          HexadecimalValue: "#DA70D6",
        },
        {
          ColorName: "PaleGoldenrod",
          RGBValue: "rgb(238, 232, 170)",
          HexadecimalValue: "#EEE8AA",
        },
        {
          ColorName: "PaleGreen",
          RGBValue: "rgb(152, 251, 152)",
          HexadecimalValue: "#98FB98",
        },
        {
          ColorName: "PaleTurquoise",
          RGBValue: "rgb(175, 238, 238)",
          HexadecimalValue: "#AFEEEE",
        },
        {
          ColorName: "PaleVioletRed",
          RGBValue: "rgb(219, 112, 147)",
          HexadecimalValue: "#DB7093",
        },
        {
          ColorName: "PapayaWhip",
          RGBValue: "rgb(255, 239, 213)",
          HexadecimalValue: "#FFEFD5",
        },
        {
          ColorName: "PeachPuff",
          RGBValue: "rgb(255, 218, 185)",
          HexadecimalValue: "#FFDAB9",
        },
        {
          ColorName: "Peru",
          RGBValue: "rgb(205, 133, 63)",
          HexadecimalValue: "#CD853F",
        },
        {
          ColorName: "Pink",
          RGBValue: "rgb(255, 192, 203)",
          HexadecimalValue: "#FFC0CB",
        },
        {
          ColorName: "Plum",
          RGBValue: "rgb(221, 160, 221)",
          HexadecimalValue: "#DDA0DD",
        },
        {
          ColorName: "PowderBlue",
          RGBValue: "rgb(176, 224, 230)",
          HexadecimalValue: "#B0E0E6",
        },
        {
          ColorName: "Purple",
          RGBValue: "rgb(128, 0, 128)",
          HexadecimalValue: "#800080",
        },
        {
          ColorName: "Red",
          RGBValue: "rgb(255, 0, 0)",
          HexadecimalValue: "#FF0000",
        },
        {
          ColorName: "RosyBrown",
          RGBValue: "rgb(188, 143, 143)",
          HexadecimalValue: "#BC8F8F",
        },
        {
          ColorName: "RoyalBlue",
          RGBValue: "rgb(65, 105, 225)",
          HexadecimalValue: "#4169E1",
        },
        {
          ColorName: "SaddleBrown",
          RGBValue: "rgb(139, 69, 19)",
          HexadecimalValue: "#8B4513",
        },
        {
          ColorName: "Salmon",
          RGBValue: "rgb(250, 128, 114)",
          HexadecimalValue: "#FA8072",
        },
        {
          ColorName: "SandyBrown",
          RGBValue: "rgb(244, 164, 96)",
          HexadecimalValue: "#F4A460",
        },
        {
          ColorName: "SeaGreen",
          RGBValue: "rgb(46, 139, 87)",
          HexadecimalValue: "#2E8B57",
        },
        {
          ColorName: "Seashell",
          RGBValue: "rgb(255, 245, 238)",
          HexadecimalValue: "#FFF5EE",
        },
        {
          ColorName: "Sienna",
          RGBValue: "rgb(160, 82, 45)",
          HexadecimalValue: "#A0522D",
        },
        {
          ColorName: "Silver",
          RGBValue: "rgb(192, 192, 192)",
          HexadecimalValue: "#C0C0C0",
        },
        {
          ColorName: "SkyBlue",
          RGBValue: "rgb(135, 206, 235)",
          HexadecimalValue: "#87CEEB",
        },
        {
          ColorName: "SlateBlue",
          RGBValue: "rgb(106, 90, 205)",
          HexadecimalValue: "#6A5ACD",
        },
        {
          ColorName: "SlateGray",
          RGBValue: "rgb(112, 128, 144)",
          HexadecimalValue: "#708090",
        },
        {
          ColorName: "Snow",
          RGBValue: "rgb(255, 250, 250)",
          HexadecimalValue: "#FFFAFA",
        },
        {
          ColorName: "SpringGreen",
          RGBValue: "rgb(0, 255, 127)",
          HexadecimalValue: "#00FF7F",
        },
        {
          ColorName: "SteelBlue",
          RGBValue: "rgb(70, 130, 180)",
          HexadecimalValue: "#4682B4",
        },
        {
          ColorName: "Tan",
          RGBValue: "rgb(210, 180, 140)",
          HexadecimalValue: "#D2B48C",
        },
        {
          ColorName: "Teal",
          RGBValue: "rgb(0, 128, 128)",
          HexadecimalValue: "#008080",
        },
        {
          ColorName: "Thistle",
          RGBValue: "rgb(216, 191, 216)",
          HexadecimalValue: "#D8BFD8",
        },
        {
          ColorName: "Tomato",
          RGBValue: "rgb(255, 99, 71)",
          HexadecimalValue: "#FF6347",
        },
        {
          ColorName: "Turquoise",
          RGBValue: "rgb(64, 224, 208)",
          HexadecimalValue: "#40E0D0",
        },
        {
          ColorName: "Violet",
          RGBValue: "rgb(238, 130, 238)",
          HexadecimalValue: "#EE82EE",
        },
        {
          ColorName: "Wheat",
          RGBValue: "rgb(245, 222, 179)",
          HexadecimalValue: "#F5DEB3",
        },
        {
          ColorName: "White",
          RGBValue: "rgb(255, 255, 255)",
          HexadecimalValue: "#FFFFFF",
        },
        {
          ColorName: "WhiteSmoke",
          RGBValue: "rgb(245, 245, 245)",
          HexadecimalValue: "#F5F5F5",
        },
        {
          ColorName: "Yellow",
          RGBValue: "rgb(255, 255, 0)",
          HexadecimalValue: "#FFFF00",
        },
        {
          ColorName: "YellowGreen",
          RGBValue: "rgb(154, 205, 50)",
          HexadecimalValue: "#9ACD32",
        },
      ],
    };
  },
  computed: {
    computedSystemColors() {
      return Object.keys(this.systemColors).map((o) => o.toLowerCase());
    },
  },
  watch: {
    value: {
      handler(v) {
        this.load();
      },
    },
    innerValue: {
      handler(v) {
        // console.log("color selector: inner value ", v)
        this.updateColor(v);
      },
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    updateColor(v) {
      // console.log("color selector: ", v)
      if (v !== null && v !== undefined) {
          let val = v;
          if (typeof v === "object" && v !== null) {
            val = v.hex;
          }
          if (
            !this.hexColorsOnly &&
            Object.keys(this.systemColors).filter(
              (o) => o.toLowerCase() === val.toLowerCase()
            ).length > 0
          ) {
            this.$emit("update:value", val);
          } else {
            this.useSystemColors = false;

            this.$emit("update:value", val);
          }
        }
    },
    load() {
      if (
        this.value !== null &&
        this.value !== undefined &&
        this.systemColors !== null &&
        this.systemColors !== undefined &&
        Object.keys(this.systemColors).filter(
          (o) => o.toLowerCase() === this.value.toLowerCase()
        ).length > 0
      ) {
        // console.log("11111111111111111")
        this.useSystemColors = true;
        this.innerValue = this.value;
        return;
      }
      if (this.systemColorsOnly) {
        // console.log("2222222222222222")
        this.useSystemColors = true;
        return;
      }
      // if (this.hexColorsOnly) {
      //   this.useSystemColors = false;
      //   return;
      // }
      // console.log("333333333333", this.value)
      this.useSystemColors = false;
      if (this.value !== null && this.value !== undefined) {
        const col = this.colors.filter(
          (o) => o.ColorName.toLowerCase() === this.value.toLowerCase()
        );
        if (col.length > 0) {
          this.innerValue = col[0].HexadecimalValue;
          return;
        }
        this.innerValue = this.value;
      }

      return;
    },
    getSystemColor(v) {
      const key = Object.keys(this.systemColors).filter(
        (o) => o.toLowerCase() === v.toLowerCase()
      )[0];
      return this.systemColors[key];
    },
  },
};
</script>
